import { render, staticRenderFns } from "./fotosInstagram.vue?vue&type=template&id=2881731a"
import script from "./fotosInstagram.vue?vue&type=script&lang=js"
export * from "./fotosInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports